<template>
  <div>
    <input type="hidden" :value="JSON.stringify(services)" name="invoice_items">

    <div class="portlet light portlet-fit invoice-details-portlet" @keydown="downKeyAdd">
      <div class="portlet-title" v-if="!formMode">
        <div class="caption">
          <i class="fa fa-list"></i>
          <span class="caption-subject bold uppercase">Services et pièces</span>
          <span v-if="!readOnly" class="invoice-save-controls">
            <button
              type="button"
              class="btn btn-default btn-xs"
              title="Actualiser les détails"
              aria-label="Actualiser les détails"
              :disabled="gridReloading"
              @click="reloadDetailGrid">
              <i class="fa fa-refresh"></i>
            </button>
            <button
              type="button"
              class="btn btn-default btn-xs"
              title="Enregistrer tout"
              aria-label="Enregistrer tout"
              :disabled="pendingSaveCount > 0"
              @click="saveItems()">
              <i class="fa fa-save"></i>
            </button>
            <span v-if="pendingSaveCount === 0 && saveCycleSucceeded" class="invoice-saved-indicator" title="Enregistré" aria-label="Enregistré">
              <i class="fa fa-check"></i>
            </span>
          </span>
        </div>
        <div class="tools">
          <a href="javascript:;" class="collapse" data-original-title="" title='Afficher / Cacher'> </a>
        </div>
      </div>
      <div class="portlet-body">
        <div v-if="loading">
          <div class="text-center">
            <span style="font-size: 22px"><i class="fa fa-refresh fa-spin"></i></span>
          </div>
        </div>
        <div v-else>
          
							<!-- Véhicule -->
          <div  v-if="!readOnly" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="row">
              
              <div class="element-data"> 
                <a v-if="allowEditVehicle" href="javascript:;" id="invoice_vehicle_display" class="action-modify-vehicle" v-bind:vehicle-id="this.vehicleId"> </a>                
                <div v-if="!allowEditVehicle" id="invoice_vehicle_display"  v-bind:vehicle-id="this.vehicleId">{{this.vehicleName}}</div>  
                
                <button class="btn btn-sm purple hidden" id="action-add-service-tire" @click="actionaddservicetire"><i class="fa fa-circle-o-notch"></i> Service de pneu <i class="fa fa-plus"></i></button>  
                <input type="hidden" id="data-add-service-tire" value="">
                <button class="btn btn-sm purple hidden" id="action-add-service-oil" @click="actionaddserviceoil"><i class="fa fa-tint"></i> Service d'huile <i class="fa fa-plus"></i></button> 
                <input type="hidden" id="data-add-service-oil" value="">   
                <input type="hidden" id="data-add-service-oil-qty" value="">   
                <input type="hidden" id="data-add-part-oil-filter" value="">   
                <button class="btn btn-sm purple hidden" id="action-add-service-storage" @click="actionaddservicestorage"><i class="fa fa-archive"></i> Service d'entreposage <i class="fa fa-plus"></i></button> 
                <input type="hidden" id="data-add-service-storage" value="">   
                <button class="btn btn-sm purple hidden" id="action-add-service-tpms" @click="actionaddservicetpms"><i class="fa fa-tachometer"></i> Service TPMS <i class="fa fa-plus"></i></button>
                <input type="hidden" id="data-add-service-tpms" value="">
              </div>
            </div>
					</div>
          <div class="invoice-details-grid-wrapper">
            <div v-if="gridReloading" class="invoice-details-grid-overlay">
              <span><i class="fa fa-refresh fa-spin"></i> Rechargement des détails...</span>
            </div>
          <table id="invoice-details-table" class="table table-bordered" style="margin-bottom: 5px">
            <thead>
              <tr>
                <th v-if="!readOnly">&nbsp;</th>
                <th v-if="!readOnly">&nbsp;</th>
                <th>&nbsp;</th>
                <th style="width: 470px">Services et pièces</th>
                <th>Description</th>
                <th v-if="!isSoumission" class="soumission-compact-col" style="width: 62px;">Commander</th>
                <th class="width-min-nowrap" style="width: 70px;">Quantité</th>
                <th v-if="isSoumission" class="width-min-nowrap soumission-compact-col" style="max-width: 62px; width: 62px;">Groupe</th>
                <th v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="width: 62px;">$ suggéré<wbr>unitaire</th>
                <th v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="width: 62px;">$ coutant<wbr>unitaire</th>
                <th v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="width: 62px;">Profit $ min</th>
                <th v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="width: 62px;">Profit %<wbr>min</th>
                <th class="width-min-nowrap text-right">Prix unitaire</th>
                <th v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="width: 62px;">Profit %<wbr>réel</th>
                <th class="width-min-nowrap text-right">Sous-Total</th>
                <th class="width-min-nowrap soumission-compact-col text-right">T.V. Pneu</th>
                <th class="width-min-nowrap text-right">Total</th>
              </tr>
            </thead>
            <draggable v-model="items" tag="tbody" handle=".draggable-handle" @update="handleChange()">
                <!-- removed to make it work with template tag but impact is unknown v-bind:key="index" -->
                <!-- <tr v-if="item.type == 'service'">
                  <td colspan="11">&nbsp;</td>
                </tr> -->
                <template v-for="(item, index) in items">
                  <tr v-if="item.is_subtotal_row" :key="`subtotal-${index}`" class="item-row is-subtotal-row">
                    <td class="width-min-nowrap draggable-handle" v-if="!readOnly" style="padding: 3px 8px; vertical-align: middle; font-size: 22px; cursor:move">
                      <i class="fa fa-bars"></i>
                    </td>
                    <td v-if="!readOnly" class="width-min-nowrap text-center">
                      <a class="btn btn-circle btn-icon-only btn-default tooltips mr-0" @click="removeSubtotal(item.service_index)" data-container="body" data-placement="top" data-original-title="Supprimer" href="javascript:;" title="Supprimer">
                        <i class="icon-trash"></i>
                      </a>
                    </td>
                    <td class="width-min-nowrap">&nbsp;</td>
                    <td class="bold">Sous-total</td>
                    <td :colspan="subtotalGapColspan - 2" style="background-color: inherit;">&nbsp;</td>
                    <td class="width-min-nowrap text-right" style="font-size: 12px;">TPS : {{getSubTotalBreakTax(index, 'tps')}} $</td>
                    <td class="width-min-nowrap text-right" style="font-size: 12px;">TVQ : {{getSubTotalBreakTax(index, 'tvq')}} $</td>
                    <td class="width-min-nowrap text-right bold" style="min-width: 100px;">{{getSubTotalBreakSubtotal(index)}} $</td>
                    <td class="width-min-nowrap text-right" style="width: 50px;">{{getSubTotalBreakTireTax(index)}} $</td>
                    <td class="width-min-nowrap text-right bold">{{getSubTotalBreakTotal(index)}} $</td>
                  </tr>
                  <tr v-else :key="`item-${index}`" class="item-row" :class="{'is-done':item.invoice_detail_is_done && item.part_index === undefined, 'is-service': item.part_index === undefined, 'is-unselected': isSoumission && item.part_index !== undefined && (!item.invoice_detail_selected || isCorePart(item))}">
                  <td class="width-min-nowrap" :class="{'draggable-handle' : item.part_index === undefined}" v-if="!readOnly" style="padding: 3px 8px; vertical-align: middle; font-size: 22px; cursor:move">
                    <i v-if="item.part_index === undefined" class="fa fa-bars"></i>
                  </td>
                  <td v-if="!readOnly && item.invoice_detail_is_garanteed!=0">G</td>
                  <td class="width-min-nowrap text-center" v-if="!readOnly && item.invoice_detail_is_garanteed==0" :style="{'padding': item.part_index === undefined ? '8px' :'3px 8px'}">
                    <div>
                      <label v-if="item.part_index !== undefined && isSoumission && !isCorePart(item)" class="soumission-part-selected tooltips" data-container="body" data-placement="top" data-original-title="Inclure cette pièce dans la soumission" title="Choisi">
                        <input type="checkbox" v-model="item.invoice_detail_selected" @change="handleChange(item)">
                        <span>Choisi</span>
                      </label>
                      <span v-if="item.part_index !== undefined && isSoumission && isCorePart(item)" class="soumission-core-label">Consigne<br>non comptabilisée</span>
                      <a v-if="item.part_index !== undefined && !isSoumission" class="btn btn-circle btn-icon-only btn-default tooltips mr-0" @click="returnPart(item.service_index, item.part_index, itemInventoryCount(item))" data-container="body" data-placement="top" data-original-title='Retourner pièce' href="javascript:;" title="Retourner pièce">
                        <i class="icon-action-undo"> </i>
                      </a>
                      <a v-if="item.part_index !== undefined && isSoumission" class="btn btn-circle btn-icon-only btn-default tooltips mr-0" @click="removeSoumissionPart(item.service_index, item.part_index)" data-container="body" data-placement="top" data-original-title="Supprimer" href="javascript:;" title="Supprimer">
                        <i class="icon-trash"></i>
                      </a>
                      <a v-if="item.part_index === undefined || !isSoumission" class="btn btn-circle btn-icon-only btn-default tooltips mr-0" @click="removeItem(item.service_index, item.part_index)" data-container="body" data-placement="top" data-original-title="Retourner dans l'inventaire" href="javascript:;" :title="item.part_index === undefined ? 'Supprimer':'Retourner dans l\'inventaire'">
                        <i v-if="item.part_index === undefined" class="icon-trash"></i><span v-if="item.part_index !== undefined">I</span>
                       </a>
                    </div>
                    <div class="text-center" v-if="item.part_index === undefined && !isSoumission" style="margin-top: 5px; font-size: 12px">
                      Fait <br>
                      <input type="checkbox" v-model="item.invoice_detail_is_done" @change="handleChange(item)">
                    </div>
                    <div class="text-center" v-if="item.part_index === undefined && isSoumission" style="margin-top: 5px; font-size: 12px">
                      Sél. <br>
                      <input
                        type="checkbox"
                        class="invoice_detail_is_selected"
                        :id="`invoice_detail_is_selected[${item.service_index ?? 0}]`"
                        :value="item.invoice_detail_id ?? 0"
                        checked
                      >
                    </div>
                  </td>
                  <td class="width-min-nowrap" style="vertical-align: top;">
                    <span :title="item.part_index === undefined ? 'Service' :'Pièce'">
                      {{item.part_index === undefined ? 'S' : 'P'}}
                    </span>
                  </td>
                  <td class="input" style="width: 400px; min-width: 400px;">
                    <div v-if="!readOnly && item.invoice_detail_is_garanteed==0">
                      <input type="hidden" v-model="item.invoice_detail_invoice_id">
                      <input type="hidden" v-model="item.invoice_detail_service_id">
                        
                      <select-two-items v-if="item.type == 'service'"
                          :endpoint="itemEndpoint" 
                          :type="item.type" 
                          v-model="item.invoice_detail_item" 
                          @selected="onSelect(item.service_index, item.part_index, $event);" 
                          @clear="onClear(item.service_index, item.part_index)" 
                          :ref="`select2-service-${item.service_index}`"
                          :initial-value="(item.invoice_detail_item.id)?item.invoice_detail_item.id.toString():''"              
                          :initial-display="item.invoice_detail_item.text"
                          :add-form-base-end-point="baseEndpoint+'service/add'"
                          :add-form-title="'Ajout d\'un service'"
                          :add-form-selector="'#form_service'"
                          :add-text-input-selector="'#service_name'"
                          :edit-form-base-end-point="baseEndpoint+'service/edit'"
                          :edit-form-title="'Modifier un service'"
                          :edit-form-selector="'#form_service'"
                          :edit-text-input-selector="'#service_name'"
                          :allow-add="allowAddServices"
                          :allow-edit="allowEditServices"
                          :dropdownParent="formMode ? '.modal-invoice' : 'body'" />

                      <select-two-items v-else-if="item.type == 'part'"
                          :endpoint="itemEndpoint" 
                          :type="item.type" 
                          v-model="item.invoice_detail_item" 
                          @selected="onSelect(item.service_index, item.part_index, $event);focus(index)" 
                          @clear="onClear(item.service_index, item.part_index)" 
                          :ref="`select2-part-${item.service_index}-${item.part_index}`"
                          :initial-value="(item.invoice_detail_item.id)?item.invoice_detail_item.id.toString():''"  
                          :initial-display="item.invoice_detail_item.text"
                          :add-form-base-end-point="baseEndpoint+'part/add'"
                          :add-form-title="'Ajout d\'une pièce'"
                          :add-form-selector="'#form_part'"
                          :add-text-input-selector="'#part_name'"
                          :edit-form-base-end-point="baseEndpoint+'part/edit'"
                          :edit-form-title="'Modifier une pièce'"
                          :edit-form-selector="'#form_part'"
                          :edit-text-input-selector="'#part_name'"
                          :allow-add="allowAddParts"
                          :allow-edit="allowEditParts"
                          :allow-quick-add="allowAddParts"
                          :dropdownParent="formMode ? '.modal-invoice' : 'body'" />
                      
                      <small v-if="item.part_index === undefined" style="font-size:15px">
                        <a href="javascript:;" @click="addPart(item.service_index)">+ Ajouter pièce</a>
                        <span> ({{item.parts.length}}  {{item.parts.length>1 ? 'pièces' : 'pièce'}})</span>
                      </small>
                    </div>
                    <div v-else style="padding: 5px;">
                      {{item.invoice_detail_item.text}}
                    </div>
                  </td>
                  <td class="input soumission-compact-col">
                    <div v-if="!readOnly && item.invoice_detail_is_garanteed==0">
                      <textarea ref="description-box" v-if="item.part_index === undefined" class="form-control" style="width:100%; min-height: 35px; resize: vertical" v-model="item.invoice_detail_description" @change="handleChange(item)" @input="autoResize"></textarea>
                      <textarea ref="description-box" v-else class="form-control" style="width:100%; height: 35px; min-height: 35px; resize: vertical" v-model="item.invoice_detail_description" @change="handleChange(item)" @input="autoResize"></textarea>
                    </div>
                    <div v-else style="padding: 5px;" v-html="item.invoice_detail_description.replace(/\n/g, '<br>')"></div>
                  </td>
                  <td v-if="!isSoumission" class="width-min-nowrap cb text-left soumission-compact-col" style="width: 62px;">
                    <div v-if="item.part_index === undefined">
                      <div v-if="!isSoumission && !readOnly && item.invoice_detail_is_garanteed==0">
                        <div class="text-left invoice_detail_parts_status_div">
                          <input class="invoice_detail_parts_status" type="checkbox" :checked="item.invoice_detail_parts_status == 1" @change="checkboxOrderStatusChange(item, 1, $event)"> 
                          <label @click="checkboxOrderStatusChange(item, 1, $event)">Pièces à commander</label>
                        </div>
                        <div class="text-left invoice_detail_parts_status_div">
                          <input class="invoice_detail_parts_status" type="checkbox" :checked="item.invoice_detail_parts_status == 2" @change="checkboxOrderStatusChange(item, 2, $event)"> 
                          <label @click="checkboxOrderStatusChange(item, 2, $event)">Pièces commandées</label>
                        </div>
                        <div class="text-left invoice_detail_parts_status_div">
                          <input class="invoice_detail_parts_status" type="checkbox" :checked="item.invoice_detail_parts_status == 3" @change="checkboxOrderStatusChange(item, 3, $event)"> 
                          <label @click="checkboxOrderStatusChange(item, 3, $event)">Pièces reçues</label>
                        </div>
                      </div>
                      <div v-else-if="!isSoumission">
                        <div class="text-left invoice_detail_parts_status_div">
                          <i v-if="item.invoice_detail_parts_status == 1" class="fa fa-check-square-o" style="font-size: 18px;"></i>
                          <i v-else class="fa fa-square-o" style="font-size: 18px;"></i>
                          <label>Pièces à commander</label>
                        </div>
                        <div class="text-left invoice_detail_parts_status_div">
                          <i v-if="item.invoice_detail_parts_status == 2" class="fa fa-check-square-o" style="font-size: 18px;"></i>
                          <i v-else class="fa fa-square-o" style="font-size: 18px;"></i>
                          <label>Pièces commandées</label>
                        </div>
                        <div class="text-left invoice_detail_parts_status_div">
                          <i v-if="item.invoice_detail_parts_status == 3" class="fa fa-check-square-o" style="font-size: 18px;"></i>
                          <i v-else class="fa fa-square-o" style="font-size: 18px;"></i>
                          <label>Pièces reçues</label>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="!isSoumission" style="text-align: left">
                      <span :class="itemInventoryCount(item) <= 0 ? 'font-red' : 'font-black'" style="font-weight:bolder" id="inventory"> Inventaire: {{itemInventoryCount(item)}}</span>
                      <br>
                      <span :class="itemReturnCount(item) < 0 ? 'font-red' : 'font-black'" style="font-weight:bolder" id="inventory"> RT: {{itemReturnCount(item)}}</span>                      
                    </div>
                  </td>
                  <td class="width-min-nowrap input" style="width: 70px">
                    <div>
                      <div v-if="!readOnly && item.invoice_detail_is_garanteed==0">
                        <input class="form-control invoice_detail_qty select-on-focus" id="qty" ref="qty" type="number" v-model="item.invoice_detail_qty" @change="handleChange(item)">
                      </div>
                      <div v-else style="padding: 5px; text-align: right;">
                        {{item.invoice_detail_qty}}
                      </div>
                    </div>
                    <div style="margin-top: 5px" v-if="item.part_index === undefined">
                      <div v-if="!readOnly && item.invoice_detail_is_garanteed==0">
                        <input class="form-control invoice_detail_hours select-on-focus" type="number" v-model="item.invoice_detail_hours" @change="handleChange(item)">
                      </div>
                      <div v-else style="padding: 5px; text-align: right;">
                        {{item.invoice_detail_hours}}
                      </div>
                    </div>
                  </td>
                  <td v-if="isSoumission" class="width-min-nowrap soumission-group-cell soumission-compact-col" style="max-width: 62px; width: 62px;">
                    <div class="soumission-group-text" :title="item.part_group_name || ''">{{ item.part_group_name || '' }}</div>
                  </td>
                  <td v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="min-width: 62px; width: 62px;">
                    <div style="padding: 5px;">{{ formatSoumissionMoney(item.suggested_price) }}</div>
                  </td>
                  <td v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="min-width: 62px; width: 62px;">
                    <div style="padding: 5px;">{{ formatSoumissionMoney(item.cost_price) }}</div>
                  </td>
                  <td v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="min-width: 62px; width: 62px;">
                    <div style="padding: 5px;">{{ formatSoumissionMoney(item.minimum_profit) }}</div>
                  </td>
                  <td v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="min-width: 62px; width: 62px;">
                    <div style="padding: 5px;">{{ formatSoumissionPercent(item.percent_profit) }}</div>
                  </td>
                  <td class="width-min-nowrap input" style="width: 100px; position: relative">
                    <div>
                      <div v-if="!readOnly && item.invoice_detail_is_garanteed==0" style="position: relative">
                        <span style="position: absolute; top: 6px; right: 8px; font-size: 16px; user-select: none">$</span>
                        <input style="width: 100px; padding-right: 20px" class="form-control invoice_detail_price text-right select-on-focus" type="text" v-model="item.invoice_detail_price" @change="handleChange(item)">
                      </div>
                      <div v-else style="padding: 5px; text-align: right;" :class="item.invoice_detail_is_garanteed==1 ? 'text-strikethrough' : ''">
                        {{item.invoice_detail_price}} $
                      </div>
                    </div>
                    <div style="margin-top: 5px" v-if="item.part_index === undefined">
                      <div v-if="!readOnly && item.invoice_detail_is_garanteed==0" style="position: relative">
                        <span style="position: absolute; top: 6px; right: 8px; font-size: 16px; user-select: none; color:#fff">$/h</span>
                        <input style="width: 100px; padding-right: 35px" class="form-control invoice_detail_hour_rate text-right select-on-focus" type="text" v-model="item.invoice_detail_hour_rate" @change="handleChange(item)">
                      </div>
                      <div v-else style="padding: 5px; text-align: right;" >
                        {{item.invoice_detail_hour_rate}} $/h
                      </div>
                    </div>
                  </td>
                  <td v-if="isSoumission" class="width-min-nowrap text-right soumission-compact-col" style="min-width: 62px; width: 62px;">
                    <div v-if="!readOnly && item.invoice_detail_is_garanteed==0" style="padding: 2px; position: relative;">
                      <span style="position: absolute; top: 6px; right: 6px; font-size: 13px; user-select: none">%</span>
                      <input
                        style="width: 100%; padding-right: 16px"
                        class="form-control text-right select-on-focus"
                        type="text"
                        :disabled="item.part_index === undefined"
                        :value="getSoumissionActualProfitPercent(item)"
                        @change="onSoumissionProfitPercentChange(item, $event)"
                      >
                    </div>
                    <div v-else style="padding: 5px;">{{ getSoumissionActualProfitPercentDisplay(item) }}</div>
                  </td>
                  <td class="width-min-nowrap text-right" style="min-width: 100px;" :class="item.invoice_detail_is_garanteed==1 ? 'text-strikethrough' : ''">
                    <div>{{getItemSubtotal(item)}} $</div>
                    <div v-if="item.part_index === undefined" style="margin-top: 20px;">{{getItemTimeSubtotal(item)}} $</div>
                  </td>
                  <td class="width-min-nowrap input soumission-compact-col" style="width: 50px; position: relative">
                    <div v-if="!readOnly && item.invoice_detail_is_garanteed==0">                    
                      <span v-if="item.part_index === undefined" style="position: absolute; top: 14px; right: 8px; font-size: 16px; user-select: none">$</span>
                      <span v-else style="position: absolute; top: 8px; right: 8px; font-size: 16px; user-select: none">$</span>
                      <input style="width: 50px; padding-right: 20px" class="form-control invoice_detail_tire_tax text-right select-on-focus" type="text" v-model="item.invoice_detail_tire_tax" :disabled="item.part_index === undefined" @change="handleChange(item)">
                    </div>
                    <div v-else style="padding: 5px; width: 50px; text-align: right;">
                      {{item.invoice_detail_tire_tax}} $
                    </div>
                  </td>
                  <td class="width-min-nowrap text-right" :class="item.invoice_detail_is_garanteed==1 ? 'text-strikethrough' : ''">
                    <div>{{getItemTotal(item)}} $</div>
                    <div v-if="item.part_index === undefined"  style="margin-top: 20px;">{{getItemTimeTotal(item)}} $</div>
                  </td>
                </tr>
                </template>
            </draggable>
            <tfoot style="border: none">
              <tr style="border: none">
                <td colspan="5" style="border: none" v-if="!readOnly">
                  <button  class="btn purple pull-left" @click="addService"><i class="fa fa-plus"></i> Ajouter un service</button> 
                  <button class="btn purple pull-left" style="margin-left: 10px;" @click="addSubtotal"><i class="fa fa-plus"></i> Ajouter un sous-total</button>
                  
                  <!-- Groupes de Services -->
                  <div class="form-group pull-left" style="width: 50%;">
                    <label class="col-sm-5 col-md-5 col-lg-5 control-label" for="invoice_template_select" style="    margin: 6px 0;    padding: 0;    text-align: right;">Services prédéfinis:</label>
                    <div class="col-sm-7 col-md-7 col-lg-7">
                      <div class="select2-input-container input-group">
                      <select id="invoice_template_select" class="form-control invoice_template_select" name="invoice_template_select" style="width: 100%;">
                        <option value="" selected></option>
                      </select>
                      </div>
                    </div>
                  </div>    

                </td>
                <td colspan="3" style="border: none" v-else>                  
                </td>
                <td style="border: none; padding: 10px 0px; text-align: right;">
                  <b>Total heures: </b>
                </td>
                <td style="border: none; text-align: left;">
                  <b>{{totalHours}}</b>
                </td>
                <td :colspan="summaryTotalsColspan" style="border: none; padding-right: 0; padding-bottom: 0">
                  <div >
                    <table class="table-bordered text-right" style="width: 100%;">
                      <tr>
                        <td style="padding: 5px;">Total sans taxes:</td>
                        <td style="padding: 5px;">{{round(subtotal,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">Montant taxable TPS:</td>
                        <td style="padding: 5px;">{{round(taxableTpsAmount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">TPS ({{tpsValue}} %):</td>
                        <td style="padding: 5px;">{{round(tpsAmount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">Montant taxable TVQ:</td>
                        <td style="padding: 5px;">{{round(taxableTvqAmount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">TVQ ({{tvqValue}} %):</td>
                        <td style="padding: 5px;">{{round(tvqAmount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">T.V. Pneu:</td>
                        <td style="padding: 5px; min-width: 100px;">{{round(tireTotal,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px; font-weight: bold;">Total:</td>
                        <td style="padding: 5px; min-width: 100px; font-weight: bold;">{{round(grandTotal,2)}} $</td>
                      </tr>
                      <tr v-for="(payment, index) in payments" :key="index">
                        <td style="padding: 5px;">Paiement par {{payment.payment_method_name}} le {{payment.payment_date}}:</td>
                        <td style="padding: 5px; min-width: 100px;">{{round(payment.payment_amount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px; font-weight: bold;">Montant dû:</td>
                        <td style="padding: 5px; min-width: 100px; font-weight: bold;">{{round(dueAmount,2)}} $</td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </tfoot>

          </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Swal from 'sweetalert2';

export default {
  name: "invoice-detail-list",
  components: {
    draggable,
  },
  props: {
    invoiceId: {
      type: String,
      required: true
    },
    vehicleIdInitial: {
      type: Number,
      required: false,
      default: 0
    },
    baseEndpoint: {
      type: String,
      required: true
    },
    tpsValue: {
      type: Number,
      required: true
    },
    tvqValue: {
      type: Number,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    allowEditServices: {
      type: Boolean,
      default: true
    },
    allowAddServices: {
      type: Boolean,
      default: true
    },
    allowEditParts: {
      type: Boolean,
      default: true
    },
    allowAddParts: {
      type: Boolean,
      default: true
    },
    formMode: {
      type: Boolean,
      default: false
    },
    defaultHourRate: {
      type: Number,
      default: 0.00
    },
    allowEditVehicle: {
      type: Boolean,
      default: false
    },
    isSoumission: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      services: [],
      oldItems: [],
      loading: true,
      items: [],
      allItems: [],
      allExpanded: false,
      payments: [],
      updateCounter: 0,
      vehicleId: 0,
      gridReloading: false,
      rowSaveQueues: new WeakMap(),
      pendingSaveCount: 0,
      saveCycleSucceeded: true,
      saveCycleFailed: false
    }
  },
  watch: {
    items: {
      handler(){
        //this.saveItems();
      },
      deep: true
    }
  },
  async mounted(){
    this.loading = true;
    this.vehicleId = this.vehicleIdInitial
    await this.loadItems();
    await this.loadPayments();
    $(".invoice-details-portlet").on("focus", "input.select-on-focus", function() {
      $(this).trigger("select");
    });
    this.initInvoiceTemplateSelect2();
    window._vue_invoice_detail_list = this;
    setTimeout(() => {
      this.autoResize();
    }, 500);
    this.getVehicleData(this.vehicleId);
  },
  computed:{
    itemEndpoint(){
      this.updateCounter;
      return this.baseEndpoint + "invoice/select2/allitems";
    },
    isDifferent(){
      this.updateCounter;
      return JSON.stringify(this.services) != JSON.stringify(this.oldItems);
    },
    subtotal(){
      this.updateCounter;
      var value = 0;
      this.allItems.forEach((itm) => {
       if (itm.invoice_detail_is_garanteed == 0 && this.isItemIncluded(itm)) {
        value += parseFloat(itm.invoice_detail_price) * parseFloat(itm.invoice_detail_qty);
        value += parseFloat(itm.invoice_detail_hour_rate) * parseFloat(itm.invoice_detail_hours);
       }
      });
      return value;
    },
    taxableTpsAmount(){
      this.updateCounter;
      var value = 0;

      for (const itm of this.allItems) {
        if(itm.invoice_detail_taxable_tps && itm.invoice_detail_is_garanteed == 0 && this.isItemIncluded(itm)){
          value += parseFloat(this.getItemSubtotal(itm))
          value += parseFloat(this.getItemTimeSubtotal(itm));
        }
      }

      return value;
    },
    tpsAmount(){
      var value = parseFloat(this.taxableTpsAmount) * (this.tpsValue/100);
      return this.round(value, 2);
    },
    taxableTvqAmount(){
      this.updateCounter;

      var value = 0;
      for (const itm of this.allItems) {
        if(itm.invoice_detail_taxable_tvq && itm.invoice_detail_is_garanteed == 0 && this.isItemIncluded(itm)){
          value += parseFloat(this.getItemSubtotal(itm))
          value += parseFloat(this.getItemTimeSubtotal(itm));
        }
      }

      return value;
    },
    tvqAmount(){
      this.updateCounter;
      var value = parseFloat(this.taxableTvqAmount) * (this.tvqValue/100);
      return this.round(value, 2);
    },
    tireTotal() {
      this.updateCounter;
      let total = 0;
      for (const service of this.services || []) {
        if (this.isItemIncluded(service)) {
          total += parseFloat(service.invoice_detail_tire_tax) * parseFloat(service.invoice_detail_qty);
        }
        for (const part of service.parts || []) {
          if(this.isItemIncluded(part) && part.invoice_detail_tire_tax != null && (!part.invoice_detail_is_garanteed || part.invoice_detail_is_garanteed == 0)){
            total += parseFloat(part.invoice_detail_tire_tax) * parseFloat(part.invoice_detail_qty);
          }
        }
      }
      return total;
    },
    grandTotal(){
      this.updateCounter;
      var value = parseFloat(this.subtotal) + parseFloat(this.tpsAmount) + parseFloat(this.tvqAmount) + parseFloat(this.tireTotal);
      return this.round(value, 2);
    },
    totalPaid() {
      this.updateCounter;
      let total = 0;
      for (const payment of this.payments) {
        total += parseFloat(payment.payment_amount);
      }
      return this.round(total, 2);
    },
    dueAmount() {
      this.updateCounter;
      return parseFloat(this.grandTotal-this.totalPaid);
    },
    totalHours() {
      this.updateCounter;
      var value = 0;
      this.allItems.forEach(function(itm){
        value += parseFloat(itm.invoice_detail_hours);
      });
      return Math.round(value*100) / 100;
    },
    summaryTotalsColspan() {
      return this.isSoumission ? 10 : 4;
    },
    subtotalGapColspan() {
      return this.isSoumission ? 9 : 4;
    },
    itemInventoryCount() {
      this.updateCounter;
      return (item) => {
        return Math.round(parseFloat(item.part_inventory || 0) * 100) / 100;
      }
    },
    itemReturnCount() {
      this.updateCounter;
      return (item) => {
        return Math.round(parseFloat(item.part_return || 0) * 100) / 100;
      }
    }
  },
  methods:{
    focus (index) {
      // check if index has a valid value
      if (index === undefined || index === null || index < 0 || index >= this.$refs.qty.length) {
        console.warn("Invalid index for focus:", index);
        return;
      }
      this.$nextTick(() => {
        this.$refs.qty[index].focus()
        /*console.log(index)
        console.log(this.$refs.qty[index])
        console.log(this.$refs["qty"][index])*/
      })
    }, 
    async loadPayments() {
      let data = await $.get(this.baseEndpoint + "invoice/view/"+this.invoiceId+"/paymentsjson");
      this.payments.splice(0, this.payments.length);
      for (const payment of data) {
        this.payments.push(payment);
      }
    },
    async loadItems(){
      //this.loading = true;

      if(parseInt(this.invoiceId) == 0){
        this.loading = false;
        this.recomputeItems();
        return;
      }

      let data = await $.get(this.baseEndpoint + "invoice/view/"+this.invoiceId+"/details");

      if (!Array.isArray(data)) {
        console.error("Unexpected invoice detail payload", data);
        this.services = [];
        this.loading = false;
        this.recomputeItems();
        return;
      }

      this.services = data;
      this.loading = false;

      for (const res of data) {
        res.type = "service";
        res.invoice_detail_taxable_tps = res.invoice_detail_taxable_tps == "1";
        res.invoice_detail_taxable_tvq = res.invoice_detail_taxable_tvq == "1";
        res.invoice_detail_is_done = res.invoice_detail_is_done == "1";
        res.invoice_detail_hassubtotal = res.invoice_detail_hassubtotal == "1";
        res.invoice_detail_parts_status = parseInt(res.invoice_detail_parts_status);
        res.expanded = true;
        this.normalizeSoumissionFields(res);
        
        if(res.invoice_detail_service_id != 0){
          res.invoice_detail_item = {
            id: "service-"+res.invoice_detail_service_id,
            item_id: res.invoice_detail_service_id,
            text: res.service_name,
            type: "service"
          };
        }
        else{
          res.invoice_detail_item = {
            id: null,
            item_id: null,
            text: "",
            type: null
          };
        }

        var part_index = 0;

        for (const part of res.parts) {
          part.type = "part";
          part.invoice_detail_taxable_tps = part.invoice_detail_taxable_tps == "1";
          part.invoice_detail_taxable_tvq = part.invoice_detail_taxable_tvq == "1";
          part.invoice_detail_hassubtotal = false;
          part.part_inventory = parseFloat(part.part_inventory);
          part.part_return = parseFloat(part.part_return);
          part.invoice_detail_selected = part.invoice_detail_selected == null || part.invoice_detail_selected == "1" || part.invoice_detail_selected === true;
          part.invoice_detail_parts_status = 0;
          this.normalizeSoumissionFields(part);

          if(part.invoice_detail_part_id != 0){
            part.invoice_detail_item = {
              text: this.formatPartDisplay(part),
              item_id: part.invoice_detail_part_id,
              id: "part-"+part.invoice_detail_part_id,
              type: "part"
            };
          }
          else{
            part.invoice_detail_item = {
              id: null,
              item_id: null,
              text: "",
              type: null
            };
          }
        }

      }
      
      this.recomputeItems();
      this.oldItems = JSON.parse(JSON.stringify(this.services));
    },
    autoResize() {
      if(this.$refs["description-box"] !== undefined){
        for (const textarea of this.$refs["description-box"]) {
          textarea.style.height = "10px";
          textarea.style.height = (textarea.scrollHeight+2) + "px";
        }
      }
    },
    round: function(number, precision){
      number = parseFloat(number);
      number += 0.00000001;
      return number.toFixed(2);
    },
    isItemIncluded(item) {
      return !(this.isSoumission && item && item.part_index !== undefined && (item.invoice_detail_selected === false || this.isCorePart(item)));
    },
    isCorePart(item) {
      return parseInt((item && item.part_core_of_part_id) || 0, 10) > 0;
    },
    formatPartDisplay(part) {
      const partNumber = String(part.part_number || '').trim();
      // const name = part.part_name || part.name || part.part_number || '';
      const supplierName = String(part.supplier_name || '').trim().replace(/^(?:\d+\s+)+/, '');
      const supplier = supplierName ? supplierName.slice(0, 25).trim() : '—';
      const inventory = Math.round(parseFloat(part.part_inventory || 0) * 100) / 100;
      return `${partNumber} - ${supplier} - Q:[${inventory}]`;
    },
    normalizeSoumissionNumber(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const parsedValue = parseFloat(value);
      return Number.isFinite(parsedValue) ? this.round(parsedValue, 2) : null;
    },
    normalizeSoumissionFields(item) {
      item.part_group_name = item.part_group_name || "";
      item.suggested_price = this.normalizeSoumissionNumber(item.suggested_price);
      item.cost_price = this.normalizeSoumissionNumber(item.cost_price);
      item.minimum_profit = this.normalizeSoumissionNumber(item.minimum_profit);
      item.percent_profit = this.normalizeSoumissionNumber(item.percent_profit);
    },
    applySoumissionFields(target, item, type) {
      target.part_group_name = type === "part" ? (item.part_group_name || "") : "";
      target.suggested_price = this.normalizeSoumissionNumber(item.suggested_price ?? item.part_suggested_price ?? item.price ?? null);
      target.cost_price = this.normalizeSoumissionNumber(item.cost_price ?? item.part_cost_price ?? null);
      target.minimum_profit = this.normalizeSoumissionNumber(item.minimum_profit ?? item.part_group_minimum_profit ?? null);
      target.percent_profit = this.normalizeSoumissionNumber(item.percent_profit ?? item.part_group_percent_profit ?? null);
    },
    formatSoumissionMoney(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }
      return `${this.round(value, 2)} $`;
    },
    formatSoumissionPercent(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }
      return `${this.round(value, 2)} %`;
    },
    getSoumissionActualProfitPercent(item) {
      const price = parseFloat(item.invoice_detail_price);
      const cost = parseFloat(item.cost_price);

      if ((!Number.isFinite(cost) || cost === 0) && (!Number.isFinite(price) || price === 0)) {
        return "0.00";
      }

      if (!Number.isFinite(cost) || cost <= 0 || !Number.isFinite(price)) {
        return "";
      }

      return this.round((price / cost - 1) * 100, 2);
    },
    getSoumissionActualProfitPercentDisplay(item) {
      const value = this.getSoumissionActualProfitPercent(item);
      return value === "" ? "" : `${value} %`;
    },
    onSoumissionProfitPercentChange(item, event) {
      const rawValue = event && event.target ? event.target.value : "";
      const normalizedValue = (rawValue || "")
        .toString()
        .replace(',', '.')
        .replace(/[^\d.-]/g, '');

      if (normalizedValue === "") {
        if (event && event.target) {
          event.target.value = this.getSoumissionActualProfitPercent(item);
        }
        return;
      }

      const targetPercent = parseFloat(normalizedValue);
      const cost = parseFloat(item.cost_price);

      if (!Number.isFinite(targetPercent)) {
        if (event && event.target) {
          event.target.value = this.getSoumissionActualProfitPercent(item);
        }
        return;
      }

      if (!Number.isFinite(cost) || cost <= 0) {
        toastr.warning("Le coutant unitaire doit etre superieur a 0 pour calculer le profit reel.");
        if (event && event.target) {
          event.target.value = this.getSoumissionActualProfitPercent(item);
        }
        return;
      }

      item.invoice_detail_price = this.round(cost * (1 + targetPercent / 100), 2);

      if (event && event.target) {
        event.target.value = this.round(targetPercent, 2);
      }

      this.handleChange(item);
    },
    getNbPartsOfService: function(service_index){
      return this.services[service_index].parts.length;
    },
    removeEmptyLines: function(){
      for(var svc_ix in this.services){
        if(svc_ix == "move") continue;
        this.services[svc_ix].parts = this.services[svc_ix].parts.filter(function(part){
          return part.invoice_detail_part_id != null;
        })
      }

      this.services = this.services.filter(function(service){
        return service.parts.length != 0 || service.invoice_detail_service_id != null;
      })
    },
    saveItems(changedItem = null) {
      if (this.formMode) return Promise.resolve();
      if (this.pendingSaveCount === 0) {
        this.saveCycleFailed = false;
      }
      this.pendingSaveCount++;
      this.saveCycleSucceeded = false;

      const operation = !changedItem || changedItem.target
        ? this.saveAllItems()
        : this.saveChangedItem(changedItem);
      return Promise.resolve(operation)
        .catch(error => {
          this.saveCycleFailed = true;
          console.error("Unable to save invoice details", error);
          const message = error && error.responseJSON && error.responseJSON.message;
          toastr.error(message || "Une erreur est survenue lors de l'enregistrement.");
        })
        .finally(() => {
          this.pendingSaveCount--;
          if (this.pendingSaveCount === 0) {
            this.saveCycleSucceeded = !this.saveCycleFailed;
          }
        });
    },
    async saveChangedItem(changedItem) {
      let service = changedItem.part_index === undefined
        ? changedItem
        : this.services[changedItem.service_index];
      if (!service) {
        throw new Error("Service parent introuvable pour cette ligne.");
      }

      if (service !== changedItem && !parseInt(service.invoice_detail_id || 0, 10)) {
        await this.enqueueRowSave(service, true);
      }

      if (changedItem.part_index === undefined) {
        if (!parseInt(changedItem.invoice_detail_service_id || 0, 10)) return;
        await this.enqueueRowSave(changedItem);
      } else {
        if (!parseInt(changedItem.invoice_detail_part_id || 0, 10)) return;
        await this.enqueueRowSave(changedItem);
      }

      for (const part of (service.parts || [])) {
        if (!parseInt(part.invoice_detail_id || 0, 10) && parseInt(part.invoice_detail_part_id || 0, 10)) {
          await this.enqueueRowSave(part);
        }
      }
    },
    enqueueRowSave(item, allowEmptyService = false) {
      const previousSave = this.rowSaveQueues.get(item) || Promise.resolve();
      const currentSave = previousSave.catch(() => {}).then(() => this.persistRow(item, allowEmptyService));
      this.rowSaveQueues.set(item, currentSave);
      return currentSave;
    },
    async persistRow(item, allowEmptyService = false) {
      const previousItem = this.findStoredItem(item.invoice_detail_id);
      const previousSnapshot = previousItem ? JSON.parse(JSON.stringify(previousItem)) : null;
      const parentDetailId = item.part_index === undefined
        ? 0
        : parseInt(this.services[item.service_index].invoice_detail_id || 0, 10);
      const savedSnapshot = JSON.parse(JSON.stringify(item));
      const data = JSON.parse(JSON.stringify(savedSnapshot));
      delete data.parts;
      delete data.invoice_detail_item;
      delete data.expanded;
      delete data.service_index;
      delete data.part_index;

      const response = await $.post(
        this.baseEndpoint + "invoice/view/" + this.invoiceId + "/details/save-row",
        { data: data, parent_detail_id: parentDetailId, allow_empty_service: allowEmptyService ? 1 : 0 }
      );
      if (!response || !parseInt(response.invoice_detail_id || 0, 10)) {
        throw new Error("Le serveur n'a pas confirmé l'enregistrement de la ligne.");
      }

      item.invoice_detail_id = parseInt(response.invoice_detail_id, 10);
      savedSnapshot.invoice_detail_id = item.invoice_detail_id;
      if (item.part_index !== undefined) {
        item.invoice_detail_invoice_detail_id = parentDetailId;
        savedSnapshot.invoice_detail_invoice_detail_id = parentDetailId;
      }
      this.updateInventoryAfterSave(savedSnapshot, previousSnapshot);
      this.updateStoredItem(savedSnapshot);
      this.updateCounter++;
    },
    findStoredItem(detailId) {
      const id = parseInt(detailId || 0, 10);
      if (!id) return null;
      for (const service of this.oldItems) {
        if (parseInt(service.invoice_detail_id || 0, 10) === id) return service;
        for (const part of (service.parts || [])) {
          if (parseInt(part.invoice_detail_id || 0, 10) === id) return part;
        }
      }
      return null;
    },
    updateStoredItem(item) {
      const copy = JSON.parse(JSON.stringify(item));
      if (item.part_index === undefined) {
        const existingService = this.oldItems.find(service =>
          parseInt(service.invoice_detail_id || 0, 10) === parseInt(item.invoice_detail_id, 10)
        );
        if (existingService) {
          copy.parts = existingService.parts || [];
          this.oldItems.splice(this.oldItems.indexOf(existingService), 1, copy);
        } else {
          copy.parts = (item.parts || []).filter(part => parseInt(part.invoice_detail_id || 0, 10));
          this.oldItems.push(copy);
        }
        return;
      }

      const parent = this.oldItems.find(service =>
        parseInt(service.invoice_detail_id || 0, 10) === parseInt(item.invoice_detail_invoice_detail_id || 0, 10)
      );
      if (!parent) return;
      const partIndex = (parent.parts || []).findIndex(part =>
        parseInt(part.invoice_detail_id || 0, 10) === parseInt(item.invoice_detail_id, 10)
      );
      if (partIndex >= 0) {
        this.$set(parent.parts, partIndex, copy);
      } else {
        parent.parts.push(copy);
      }
    },
    updateInventoryAfterSave(item, previousItem) {
      if (this.isSoumission || item.part_index === undefined) return;

      const previousPartId = parseInt(previousItem && previousItem.invoice_detail_part_id || 0, 10);
      const currentPartId = parseInt(item.invoice_detail_part_id || 0, 10);
      const previousQuantity = parseFloat(String(previousItem && previousItem.invoice_detail_qty || 0).replace(",", ".")) || 0;
      const currentQuantity = parseFloat(String(item.invoice_detail_qty || 0).replace(",", ".")) || 0;
      const inventoryDeltas = {};

      if (previousPartId === currentPartId) {
        if (currentPartId > 0) inventoryDeltas[currentPartId] = currentQuantity - previousQuantity;
      } else {
        if (previousPartId > 0) inventoryDeltas[previousPartId] = -previousQuantity;
        if (currentPartId > 0) inventoryDeltas[currentPartId] = currentQuantity;
      }

      Object.keys(inventoryDeltas).forEach(partId => {
        const delta = inventoryDeltas[partId];
        this.services.forEach(service => {
          (service.parts || []).forEach(part => {
            if (parseInt(part.invoice_detail_part_id || 0, 10) !== parseInt(partId, 10)) return;
            const inventory = Math.round((parseFloat(part.part_inventory || 0) - delta) * 100) / 100;
            part.part_inventory = inventory;
            const text = part.invoice_detail_item && part.invoice_detail_item.text;
            if (typeof text === "string") {
              const updatedText = text.replace(/Q:\[[^\]]+\]/, "Q:[" + inventory + "]");
              if (updatedText !== text) {
                part.invoice_detail_item = Object.assign({}, part.invoice_detail_item, { text: updatedText });
              }
            }
          });
        });
      });

      for (const service of this.services) {
        const matchingPart = (service.parts || []).find(part =>
          parseInt(part.invoice_detail_part_id || 0, 10) === currentPartId
        );
        if (!matchingPart) continue;

        item.part_inventory = matchingPart.part_inventory;
        const text = item.invoice_detail_item && item.invoice_detail_item.text;
        if (typeof text === "string") {
          const updatedText = text.replace(/Q:\[[^\]]+\]/, "Q:[" + matchingPart.part_inventory + "]");
          if (updatedText !== text) {
            item.invoice_detail_item = Object.assign({}, item.invoice_detail_item, { text: updatedText });
          }
        }
        break;
      }
    },
    notifyInspectionChange(response) {
      if (response && response.inspections_changed) {
        $(document).trigger("invoice:inspections-changed", [{
          invoiceId: parseInt(response.invoice_id || this.invoiceId, 10),
          viewInvoiceId: parseInt(response.view_invoice_id || this.invoiceId, 10)
        }]);
      }
    },
    applySavedRowIds(savedData) {
      if (!Array.isArray(savedData)) {
        throw new Error("Le serveur n'a pas retourné les identifiants des lignes enregistrées.");
      }

      this.services.forEach((service, serviceIndex) => {
        const savedService = savedData[serviceIndex];
        if (!savedService) return;
        service.invoice_detail_id = parseInt(savedService.invoice_detail_id || 0, 10) || service.invoice_detail_id;
        (service.parts || []).forEach((part, partIndex) => {
          const savedPart = (savedService.parts || [])[partIndex];
          if (!savedPart) return;
          part.invoice_detail_id = parseInt(savedPart.invoice_detail_id || 0, 10) || part.invoice_detail_id;
          part.invoice_detail_invoice_detail_id = service.invoice_detail_id;
        });
      });
    },
    async reloadDetailGrid() {
      this.gridReloading = true;
      try {
        await this.loadItems();
      } finally {
        this.gridReloading = false;
      }
    },
    async saveAllItems() {
      const previousServiceIds = this.oldItems
        .map(service => parseInt(service.invoice_detail_id || 0, 10))
        .filter(id => id > 0);
      try {
        this.removeEmptyLines();
        const currentServiceIds = this.services
          .map(service => parseInt(service.invoice_detail_id || 0, 10))
          .filter(id => id > 0);
        const reloadDetails = previousServiceIds.some(id => !currentServiceIds.includes(id));
        this.gridReloading = reloadDetails;
        const response = await $.post(
          this.baseEndpoint + "invoice/view/" + this.invoiceId + "/details/save",
          { data: this.services, reload_details: reloadDetails ? 1 : 0 }
        );
        const result = Array.isArray(response) ? response : (response && response.details);
        const expandedById = {};
        for (const service of this.services) {
          if (service && service.invoice_detail_id) {
            expandedById[service.invoice_detail_id] = !!service.expanded;
          }
        }

        if (Array.isArray(result)) {
          for (const res of result) {
          res.type = "service";
          res.invoice_detail_taxable_tps = res.invoice_detail_taxable_tps == "1";
          res.invoice_detail_taxable_tvq = res.invoice_detail_taxable_tvq == "1";
          res.invoice_detail_is_done = res.invoice_detail_is_done == "1";
          res.invoice_detail_hassubtotal = res.invoice_detail_hassubtotal == "1";
          res.invoice_detail_parts_status = parseInt(res.invoice_detail_parts_status);
          res.expanded = Object.prototype.hasOwnProperty.call(expandedById, res.invoice_detail_id)
            ? expandedById[res.invoice_detail_id]
            : true;
          this.normalizeSoumissionFields(res);

          if (res.invoice_detail_service_id != 0) {
            res.invoice_detail_item = {
              id: "service-" + res.invoice_detail_service_id,
              item_id: res.invoice_detail_service_id,
              text: res.service_name,
              type: "service"
            };
          } else {
            res.invoice_detail_item = { id: null, item_id: null, text: "", type: null };
          }

          for (const part of (res.parts || [])) {
            part.type = "part";
            part.invoice_detail_taxable_tps = part.invoice_detail_taxable_tps == "1";
            part.invoice_detail_taxable_tvq = part.invoice_detail_taxable_tvq == "1";
            part.invoice_detail_hassubtotal = false;
            part.part_inventory = parseFloat(part.part_inventory);
            part.part_return = parseFloat(part.part_return);
            part.invoice_detail_selected = part.invoice_detail_selected == null || part.invoice_detail_selected == "1" || part.invoice_detail_selected === true;
            part.invoice_detail_parts_status = 0;
            this.normalizeSoumissionFields(part);

            if (part.invoice_detail_part_id != 0) {
              part.invoice_detail_item = {
                text: this.formatPartDisplay(part),
                item_id: part.invoice_detail_part_id,
                id: "part-" + part.invoice_detail_part_id,
                type: "part"
              };
            } else {
              part.invoice_detail_item = { id: null, item_id: null, text: "", type: null };
            }
          }
          }

          this.services = result;
          this.recomputeItems();
          this.oldItems = JSON.parse(JSON.stringify(this.services));
        } else {
          this.applySavedRowIds(response && response.saved_data);
          this.recomputeItems();
          this.oldItems = JSON.parse(JSON.stringify(this.services));
        }
        if (reloadDetails) {
          this.notifyInspectionChange(response);
        }
      } finally {
        this.gridReloading = false;
      }
    },
    downKeyAdd(ev){
      if(ev.keyCode == '40'){
        ev.preventDefault();
        this.addService(ev);
      }
    },
    recomputeItems: function(){
      var allItems = [];
      var items = [];
      var service_index = 0;
      this.services.sort((a,b) => parseInt(a.invoice_detail_order) - parseInt(b.invoice_detail_order))
      this.services.forEach(function(service){
        service.service_index = service_index
        items.push(service);
        allItems.push(service);
        if(service.parts !== undefined){
          var part_index = 0;
          service.parts.sort((a,b) => parseInt(a.invoice_detail_order) - parseInt(b.invoice_detail_order))
          service.parts.forEach(function(part){
            part.part_index = part_index;
            part.service_index = service_index
            if(service.expanded){
              items.push(part);
            }
            allItems.push(part);
            part_index++;
          })
        }

        if (service.invoice_detail_hassubtotal) {
          items.push({
            type: "subtotal",
            is_subtotal_row: true,
            service_index: service_index
          });
        }

        service_index++;
      });
      this.items = items;
      this.allItems = allItems;
    },
    toggleExpand: function(service_index){
      this.services[service_index].expanded = !this.services[service_index].expanded;

      var isExpandAll = false;
      this.services.forEach(function(service){
        if(!isExpandAll && service.expanded){
          isExpandAll = true;
        }
      });
      
      this.allExpanded = isExpandAll;
      this.recomputeItems();
      this.updateCounter++;
    },
    toggleExpandAll: function(){
      var that = this;
      this.allExpanded = !this.allExpanded;
      this.services.forEach(function(service){
        service.expanded = that.allExpanded;
      });
      this.recomputeItems();
      this.updateCounter++;
    },
    addService: function(event, data = null, fromPredefined = false){
      var that = this;

      console.log(data);
      
      var index = 0;
      if(this.services[this.services.length-1] !== undefined){
        index = parseInt(this.services[this.services.length-1].invoice_detail_order ?? 0) + 1; // Index service
      }
      
      //console.log(this.services)
      let parts_status = true;

      if (!data || data == null || data == undefined) {
        console.log("No service data");
        this.services.push({
          type: "service",
          invoice_detail_id: null,
          invoice_detail_item: {id:null, text:"", type:null},
          invoice_detail_part_id: null,
          invoice_detail_service_id: null,
          invoice_detail_invoice_id: that.invoiceId,
          invoice_detail_description: "",
          invoice_detail_price: "0.00",
          invoice_detail_qty: "1.00",
          invoice_detail_hours: "0.00",
          invoice_detail_tire_tax: "0.00",
          invoice_detail_hour_rate: this.defaultHourRate,
          invoice_detail_taxable_tps: true,
          invoice_detail_taxable_tvq: true,
          invoice_detail_parts_status: parts_status,
          invoice_detail_hassubtotal: this.isSoumission,
          part_group_name: "",
          suggested_price: null,
          cost_price: null,
          minimum_profit: null,
          percent_profit: null,
          service_index: index,
          invoice_detail_order: index,
          expanded: false,
          invoice_detail_is_done: false,
          parts: [],
          invoice_detail_in_return_list: 0,
          invoice_detail_is_garanteed: 0
        });

        setTimeout(()=>{
          var count = that.services.length - 1;
          //console.log(count)
          //console.log(index)
          this.$refs["select2-service-"+count][0].open()
        }, 50)
      } else {
        console.log("Has service data");
        console.log(data);
        this.services.push({
          type: "service",
          invoice_detail_id: null,
          invoice_detail_item: {id:data.service_id, text:data.service_name, type:null},
          invoice_detail_part_id: null,
          invoice_detail_service_id: data.service_id,
          invoice_detail_invoice_id: that.invoiceId,
          invoice_detail_description: data.service_description,
          invoice_detail_price: data.service_selling_price,
          invoice_detail_qty: data.service_quantity_fixed,
          invoice_detail_hours: data.service_quantity_per_hour,
          invoice_detail_hour_rate: data.service_rate_per_hour === undefined || data.service_rate_per_hour == null ? 
            data.default_service_rate_per_hour 
            : data.service_rate_per_hour,
          invoice_detail_taxable_tps: true,
          invoice_detail_taxable_tvq: true,
          invoice_detail_hassubtotal: this.isSoumission,
          part_group_name: "",
          suggested_price: this.normalizeSoumissionNumber(data.suggested_price ?? data.service_selling_price ?? data.price ?? null),
          cost_price: this.normalizeSoumissionNumber(data.cost_price ?? null),
          minimum_profit: this.normalizeSoumissionNumber(data.minimum_profit ?? null),
          percent_profit: this.normalizeSoumissionNumber(data.percent_profit ?? null),
          service_index: index,
          invoice_detail_order: index,
          expanded: false,
          invoice_detail_is_done: false,
          invoice_detail_tire_tax: "0.00",
          invoice_detail_parts_status: data.service_order_part_default === undefined ? parts_status : data.service_order_part_default,
          parts: [] ,
          invoice_detail_in_return_list: 0,
          invoice_detail_is_garanteed: 0
        });
        
        if (data.part && data.part != null && data.part != undefined) {
          data.parts = [data.part];
        }

        if (data.parts != null && data.parts.length > 0) {
          let lastService = this.services[this.services.length-1];
          const lastServiceIndex = this.services.length - 1;

          if(lastService.parts == undefined){
            lastService.parts = [];
          }

          for (const part of data.parts) {
            this.checkInventory(part, lastServiceIndex, -1, fromPredefined );
          }

          lastService.expanded = true;
        }

      }

      this.recomputeItems();
    },
    addSubtotal: function(){
      if (!this.services.length) {
        toastr.error("Ajoutez d'abord un service avant de créer un sous-total.");
        return;
      }

      const lastService = this.services[this.services.length - 1];
      if (lastService.invoice_detail_hassubtotal) {
        toastr.warning("Le dernier service a deja un sous-total.");
        return;
      }

      lastService.invoice_detail_hassubtotal = true;
      this.recomputeItems();
      this.saveItems(lastService);
    },
    removeSubtotal: function(service_index){
      const service = this.services[service_index];
      if (!service) {
        return;
      }

      service.invoice_detail_hassubtotal = false;
      this.recomputeItems();
      this.saveItems(service);
    },
    async returnPart(service_index, part_index, inventory) {
      let result = await Swal.fire({
        title: "Retour pièce",
        text: "Êtes-vous sûr de placer cette ligne dans la liste des pièces à retourner?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: "Annuler",
        denyButtonText: "Retour pièce",
        confirmButtonText: "Retour garanti"
      })

      //console.log(this.services[service_index].parts[part_index])

      if(result.isConfirmed) {
        let invoice_detail_id = this.services[service_index].parts[part_index].invoice_detail_id;
        try {
          let result = await $.post(`${window.baseUrl}invoice/setparttoreturn`, { item_id: invoice_detail_id, value: 1, garanteed: 1}, "json");
          if(result.is_success) {
            toastr.success("La pièce est placée dans la liste des pièces à retourner.");
            // this.services[service_index].parts.splice(part_index, 1); laisser la piece garantie sur l'écran
            this.services[service_index].parts[part_index].invoice_detail_in_return_list = 1;
            this.services[service_index].parts[part_index].invoice_detail_is_garanteed = 1;
            this.recomputeItems();
          } else {
            Swal.fire("Error", "Une erreur s'est produite. Veuillez réessayer.", "error");
          }
        } catch (e) {
          console.error(e);
          Swal.fire("Error", "Une erreur s'est produite. Veuillez réessayer.", "error");
        }
      }
      else if(result.isDenied) {
        let invoice_detail_id = this.services[service_index].parts[part_index].invoice_detail_id;
        try {
          let result = await $.post(`${window.baseUrl}invoice/setparttoreturn`, { item_id: invoice_detail_id, value: 1, garanteed: 0}, "json");
          if(result.is_success) {
            toastr.success("La pièce est placée dans la liste des pièces à retourner.");
            this.removePartAndLinkedCore(service_index, part_index);
            this.recomputeItems();
          } else {
            Swal.fire("Error", "Une erreur s'est produite. Veuillez réessayer.", "error");
          }
        } catch (e) {
          console.error(e);
          Swal.fire("Error", "Une erreur s'est produite. Veuillez réessayer.", "error");
        }
      }

      this.saveItems();
    },
    removeItem: function(service_index, part_index){
      //console.log(service_index, part_index)
      let _this = this;
      var msg = ""
      var service = _this.services[service_index];
      //console.log(service.service_id)
      //console.log(service.count)
      var title = "";
      if(part_index!=undefined && part_index>=0)
      {
        msg = "Êtes-vous sûr de retourner cet item en inventaire"
        title = "Retourner l'item en inventaire";
      }
      else
      {
        msg = "Êtes-vous sûr de supprimer cet item"
        title = "Supprimer un item";
      }
      if(service.count>0)
      {
        msg += " ainsi que l'inspection?";
      } else {        
        msg += "?"
      }
      bootbox.dialog({
        title: title,
        message: msg,
        buttons: {				
          remove: {
            label: L('YES_WORD'),
            className: "btn-danger",
            callback: function() {
              if(part_index === undefined){
                _this.services.splice(service_index, 1);
              }
              else{
                _this.removePartAndLinkedCore(service_index, part_index);
              }
              _this.recomputeItems();
              _this.saveItems();
            }
          },					
          cancel: {
            label: L("CANCEL"),
            className: "btn",
            callback: function() {

            }
          }
        }
      })
      
    },
    removeSoumissionPart: function(service_index, part_index){
      let _this = this;

      bootbox.dialog({
        title: "Supprimer un item",
        message: "Êtes-vous sûr de supprimer cet item?",
        buttons: {
          remove: {
            label: L('YES_WORD'),
            className: "btn-danger",
            callback: function() {
              if (
                _this.services[service_index] &&
                Array.isArray(_this.services[service_index].parts) &&
                part_index !== undefined &&
                part_index >= 0
              ) {
                _this.removePartAndLinkedCore(service_index, part_index);
                _this.recomputeItems();
                _this.saveItems();
              }
            }
          },
          cancel: {
            label: L("CANCEL"),
            className: "btn"
          }
        }
      })
    },
    addPart: function(ix){
      var that = this;
      var service = this.services[ix];

      var index = 0;
      if(service.parts[service.parts.length-1] !== undefined){
        index = parseInt(service.parts[service.parts.length-1].invoice_detail_order) + 1;
      }

      //console.log(service.parts)

      service.parts.push({
        type: "part",
        new: "NEWWWWW",
        invoice_detail_id: null,
        invoice_detail_item: { id: null, text: "", type: null },
        invoice_detail_part_id: null,
        invoice_detail_service_id: null,
        invoice_detail_invoice_id: that.invoiceId,
        invoice_detail_description: "",
        invoice_detail_price: "0.00",
        invoice_detail_qty: "1.00",
        invoice_detail_hours: "0.00",
        invoice_detail_hour_rate: "0.00",
        invoice_detail_taxable_tps: true,
        invoice_detail_taxable_tvq: true,
        part_group_name: "",
        suggested_price: null,
        cost_price: null,
        minimum_profit: null,
        percent_profit: null,
        invoice_detail_is_done: false,
        invoice_detail_selected: true,
        service_index: ix,
        invoice_detail_order: index,
        part_index: index,
        invoice_detail_in_return_list: 0,
        invoice_detail_is_garanteed: 0
      })
      service.expanded = true;
      this.recomputeItems();

      setTimeout(() => {
        var count = service.parts.length;
        that.$refs["select2-part-"+ix+"-"+(count-1)][0].openFocus = true;
      }, 50)
    },
    fixPrice: function(item){
      item.invoice_detail_price = item.invoice_detail_price.replace(/[^\d.-]/g,'');
      if(item.invoice_detail_price == "") item.invoice_detail_price = 0;
      item.invoice_detail_price = parseFloat(item.invoice_detail_price).toFixed(2);
    },
    getItemSubtotal: function(item){
      return this.round(item.invoice_detail_price * item.invoice_detail_qty, 2)
    },
    getItemTimeSubtotal: function(item){
      return this.round(item.invoice_detail_hour_rate * item.invoice_detail_hours, 2)
    },
    getItemTotal: function(item){
      var subtotal = parseFloat(this.getItemSubtotal(item));

      var tps = 0;
      if(item.invoice_detail_taxable_tps){
        tps = subtotal * this.tpsValue / 100;
      }
      tps = Math.round(tps * 100) / 100;

      var tvq = 0;
      if(item.invoice_detail_taxable_tvq){
        tvq = subtotal * this.tvqValue / 100;
      }
      tvq = Math.round(tvq * 100) / 100;

      var total = subtotal + tps + tvq;
      if(item.invoice_detail_tire_tax != null){
        total += parseFloat(item.invoice_detail_tire_tax) * parseFloat(item.invoice_detail_qty)
      }

      return this.round(total, 2);
    },
    getItemTimeTotal: function(item){
      var subtotal = parseFloat(this.getItemTimeSubtotal(item));

      var tps = 0;
      if(item.invoice_detail_taxable_tps){
        tps = subtotal * this.tpsValue / 100;
      }
      tps = Math.round(tps * 100) / 100;

      var tvq = 0;
      if(item.invoice_detail_taxable_tvq){
        tvq = subtotal * this.tvqValue / 100;
      }
      tvq = Math.round(tvq * 100) / 100;

      var total = subtotal + tps + tvq;

      return this.round(total, 2);
    },
    getSubTotalBreakSubtotal: function(index){
      let subtotal = 0;

      for (let i = 0; i < index; i++) {
        const row = this.items[i];
        if (row.is_subtotal_row) {
          subtotal = 0;
          continue;
        }

        if (row.invoice_detail_is_garanteed != 0 || !this.isItemIncluded(row)) {
          continue;
        }

        subtotal += Math.round(parseFloat(this.getItemSubtotal(row))*100)/100;
        if (row.part_index === undefined) {
          subtotal += Math.round(parseFloat(this.getItemTimeSubtotal(row))*100)/100;
        }
      }

      return this.round(subtotal, 2);
    },
    getSubTotalBreakTax: function(index, taxType){
      let total = 0;
      const flag = taxType === 'tps' ? 'invoice_detail_taxable_tps' : 'invoice_detail_taxable_tvq';
      const rate = taxType === 'tps' ? this.tpsValue : this.tvqValue;

      for (let i = 0; i < index; i++) {
        const row = this.items[i];
        if (row.is_subtotal_row) {
          total = 0;
          continue;
        }

        if (row.invoice_detail_is_garanteed != 0 || !this.isItemIncluded(row) || !row[flag]) {
          continue;
        }

        total += Math.round(parseFloat(this.getItemSubtotal(row)) * rate) / 100;
        if (row.part_index === undefined) {
          total += Math.round(parseFloat(this.getItemTimeSubtotal(row)) * rate) / 100;
        }
      }

      return this.round(total, 2);
    },
    getSubTotalBreakTireTax: function(index){
      let total = 0;

      for (let i = 0; i < index; i++) {
        const row = this.items[i];
        if (row.is_subtotal_row) {
          total = 0;
          continue;
        }

        if (row.invoice_detail_is_garanteed != 0 || !this.isItemIncluded(row) || row.invoice_detail_tire_tax == null) {
          continue;
        }

        total += parseFloat(row.invoice_detail_tire_tax || 0) * parseFloat(row.invoice_detail_qty || 0);
      }

      return this.round(total, 2);
    },
    getSubTotalBreakTotal: function(index){
      let total = 0;

      for (let i = 0; i < index; i++) {
        const row = this.items[i];
        if (row.is_subtotal_row) {
          total = 0;
          continue;
        }

        if (row.invoice_detail_is_garanteed != 0 || !this.isItemIncluded(row)) {
          continue;
        }

        total += Math.round(parseFloat(this.getItemTotal(row))*100)/100;
        if (row.part_index === undefined) {
          total += Math.round(parseFloat(this.getItemTimeTotal(row))*100)/100;
        }
      }

      return this.round(total, 2);
    },
    applySubtotalMarkersFromItems: function(){
      const previousFlags = this.services.map(service => !!service.invoice_detail_hassubtotal);

      this.services.forEach(service => {
        service.invoice_detail_hassubtotal = false;
      });

      for (let i = 0; i < this.items.length; i++) {
        const row = this.items[i];
        if (!row.is_subtotal_row) {
          continue;
        }

        if (i > 0 && this.items[i - 1].is_subtotal_row) {
          this.services.forEach((service, index) => {
            service.invoice_detail_hassubtotal = previousFlags[index];
          });
          toastr.error("Impossible de déplacer un sous-total sous un autre sous-total.");
          return false;
        }

        let anchorService = null;
        for (let j = i - 1; j >= 0; j--) {
          const previousRow = this.items[j];
          if (!previousRow.is_subtotal_row && previousRow.part_index === undefined) {
            anchorService = previousRow;
            break;
          }
        }

        if (!anchorService) {
          this.services.forEach((service, index) => {
            service.invoice_detail_hassubtotal = previousFlags[index];
          });
          toastr.error("Le sous-total doit rester apres un service.");
          return false;
        }

        anchorService.invoice_detail_hassubtotal = true;
      }

      return true;
    },
    onSelect: function(service_index, part_index, item){
      var split = item.id.toString().split("-");
      var id = split[1];
      var type = split[0];

      if(part_index === undefined) { // Service
        this.services[service_index].invoice_detail_part_id = null;
        this.services[service_index].invoice_detail_service_id = id;
        this.services[service_index].invoice_detail_description = item.description;
        this.services[service_index].invoice_detail_qty = item.service_quantity_fixed;
        this.services[service_index].invoice_detail_price = item.price;
        this.services[service_index].invoice_detail_hours = item.service_quantity_per_hour;
        if (item.service_rate_per_hour === undefined || item.service_rate_per_hour == null) {
          this.services[service_index].invoice_detail_hour_rate = item.default_service_rate_per_hour;
        } else {
          this.services[service_index].invoice_detail_hour_rate = item.service_rate_per_hour;
        }
        this.services[service_index].invoice_detail_tire_tax = 0;
        this.services[service_index].invoice_detail_parts_status = item.service_order_part_default;
        this.applySoumissionFields(this.services[service_index], item, type);
      }
      else { // Pièce
        this.removeLinkedCorePart(service_index, part_index);
        for (const part of this.allItems) {
          if(part.type == "part" && part.invoice_detail_part_id == id && part != item) {
            item.part_inventory = part.part_inventory;
            item.part_return = part.part_return;
            break;
          }
        }

        if (!item.label || item.label == ''){
          item.label = item.part_number;
        }
        this.services[service_index].parts[part_index].invoice_detail_part_id = id;
        this.services[service_index].parts[part_index].invoice_detail_service_id = null;
        this.services[service_index].parts[part_index].invoice_detail_description = item.description;
        this.services[service_index].parts[part_index].invoice_detail_price = item.price == null || item.price == 0 ? item.part_suggested_price : item.price;
        this.services[service_index].parts[part_index].invoice_detail_tire_tax = item.tire_tax;
        this.services[service_index].parts[part_index].part_inventory = item.part_inventory;
        this.services[service_index].parts[part_index].part_return = item.part_return;
        this.applySoumissionFields(this.services[service_index].parts[part_index], item, type);
        this.addLinkedCorePart(service_index, part_index, item);

        this.checkInventory(item,service_index,part_index, false);
      }

      this.updateCounter++;
      this.handleChange(this.services[service_index].parts[part_index] || this.services[service_index]);
    },
    //ajouter la piece si on confirme ou si l'inventaire est suffisant.
    //si un index est spécifié, supprimer la piece si on clique le X
    //si provient de predefined, on doit ajouter la piece
    checkInventory: function(part,service_index,part_index, fromPredefined){
      if(part.part_inventory <= 0 && !this.isSoumission) {
		      let _this = this;
          if (!part.label) {
            part.label = part.part_number;
          }
          bootbox.dialog({
            title: "Attention!",
            message: `<span class="bold font-red">La pièce ${part.label} n'est pas en inventaire!</span>`,
            buttons: {
              ok: {
                label: "Continuer",
                className: "btn blue",
                callback: function() {
                   console.log('analysing part interface status...');
                    console.log(part_index);
                    console.log(service_index);
                    if (part_index == -1 && fromPredefined)
                     _this.addPartAfterCheck(part,service_index);
                   else
                    console.log('not adding');
                }
              }
            },
			      onEscape: function() {
              if (part_index > -1){
                console.log('removing part...'+part_index);
                _this.removePartAndLinkedCore(service_index, part_index);
                _this.recomputeItems();
                _this.saveItems();
              }
            }
          })
        } else {
          console.log('analysing part interface status with OK inventory!');
          console.log(part_index);
          console.log(service_index);
          if (fromPredefined)
            this.addPartAfterCheck(part,service_index);
          else
            console.log('not adding');
        }
    },
    getPartId: function(part) {
      const rawId = part.part_id || part.item_id || part.id || 0;
      return parseInt(rawId.toString().replace(/^part-/, ''), 10) || 0;
    },
    buildInvoicePartDetail: function(part, serviceIndex, partIndex, quantity){
      const partId = this.getPartId(part);
      const partName = part.part_name || part.name || part.description || part.part_number || '';
      const rawSellingPrice = part.part_selling_price ?? part.price ?? part.fixed_price;
      const sellingPrice = rawSellingPrice == null || parseFloat(rawSellingPrice) === 0
        ? (part.part_suggested_price ?? 0)
        : rawSellingPrice;

      return {
        type: "part",
        new: "NEWWWWW",
        invoice_detail_id: null,
        invoice_detail_item: { id: "part-" + partId, text: this.formatPartDisplay(part), type: "part" },
        invoice_detail_part_id: partId,
        invoice_detail_service_id: null,
        invoice_detail_invoice_id: this.invoiceId,
        invoice_detail_description: partName,
        invoice_detail_price: sellingPrice,
        invoice_detail_qty: quantity ?? part.part_quantity_fixed ?? part.quantity ?? "1.00",
        invoice_detail_hours: "0.00",
        invoice_detail_hour_rate: "0.00",
        invoice_detail_taxable_tps: true,
        invoice_detail_taxable_tvq: true,
        invoice_detail_tire_tax: part.part_tire_tax ?? part.tire_tax ?? "0.00",
        part_number: part.part_number || part.label || part.name || '',
        part_name: partName,
        supplier_name: part.supplier_name || '',
        part_group_name: part.part_group_name || "",
        part_core_part_id: part.part_core_part_id || null,
        part_core_of_part_id: part.part_core_of_part_id || null,
        part_core_part_item: part.part_core_part_item || null,
        suggested_price: this.normalizeSoumissionNumber(part.part_suggested_price ?? part.suggested_price ?? sellingPrice),
        cost_price: this.normalizeSoumissionNumber(part.part_cost_price ?? part.cost_price ?? null),
        minimum_profit: this.normalizeSoumissionNumber(part.minimum_profit ?? null),
        percent_profit: this.normalizeSoumissionNumber(part.percent_profit ?? null),
        invoice_detail_is_done: false,
        invoice_detail_selected: true,
        service_index: serviceIndex,
        invoice_detail_order: partIndex,
        part_inventory: part.part_inventory ?? 0,
        part_return: part.part_return ?? 0,
        part_index: partIndex,
        invoice_detail_in_return_list: 0,
        invoice_detail_is_garanteed: 0
      };
    },
    removeLinkedCorePart: function(serviceIndex, partIndex) {
      const service = this.services[serviceIndex];
      if (!service || !Array.isArray(service.parts)) return;
      const parent = service.parts[partIndex];
      const next = service.parts[partIndex + 1];
      const parentId = parseInt((parent && parent.invoice_detail_part_id) || 0, 10);
      if (parentId > 0 && next && parseInt(next.part_core_of_part_id || 0, 10) === parentId) {
        service.parts.splice(partIndex + 1, 1);
      }
    },
    removePartAndLinkedCore: function(serviceIndex, partIndex) {
      const service = this.services[serviceIndex];
      if (!service || !Array.isArray(service.parts)) return;
      this.removeLinkedCorePart(serviceIndex, partIndex);
      service.parts.splice(partIndex, 1);
    },
    addLinkedCorePart: function(serviceIndex, partIndex, part) {
      console.log('looking for linked core part');
      if (this.isCorePart(part) || !part.part_core_part_item) return;
      console.log('adding linked core part');
      const service = this.services[serviceIndex];
      if (!service || !Array.isArray(service.parts)) return;

      const core = part.part_core_part_item;
      const coreId = this.getPartId(core);
      if (coreId <= 0) return;
      console.log('core part id: ' + coreId);
      const next = service.parts[partIndex + 1];
      if (next && parseInt(next.invoice_detail_part_id || 0, 10) === coreId) return;
      console.log('core part found, adding...');
      const parent = service.parts[partIndex];
      const coreDetail = this.buildInvoicePartDetail(core, serviceIndex, partIndex + 1, parent ? parent.invoice_detail_qty : "1.00");
      coreDetail.part_core_of_part_id = coreDetail.part_core_of_part_id || this.getPartId(part);
      service.parts.splice(partIndex + 1, 0, coreDetail);
    },
    addPartAfterCheck: function(part, index = -1){
      console.log('adding part after check');
      const effectiveServiceIndex = index > -1 ? index : this.services.length - 1;
      const thatService = this.services[effectiveServiceIndex];
      if (!thatService || !Array.isArray(thatService.parts)) return;
      const newPartIndex = thatService.parts.length;
      thatService.parts.push(this.buildInvoicePartDetail(part, effectiveServiceIndex, newPartIndex));
      this.addLinkedCorePart(effectiveServiceIndex, newPartIndex, part);
      this.recomputeItems();
      this.handleChange(thatService.parts[newPartIndex]);
    },
    onClear: function(service_index, part_index){
      if(part_index === undefined) { // Service
        this.services[service_index].invoice_detail_part_id = null;
        this.services[service_index].invoice_detail_service_id = null;
        this.applySoumissionFields(this.services[service_index], {}, "service");
      }
      else { // Pièce
        this.removeLinkedCorePart(service_index, part_index);
        this.services[service_index].parts[part_index].invoice_detail_part_id = null;
        this.services[service_index].parts[part_index].invoice_detail_service_id = null;
        this.applySoumissionFields(this.services[service_index].parts[part_index], {}, "part");
      }
      this.updateCounter++;
    },
    cancelChanges: function(){
      let _this = this;
      bootbox.dialog({
        title: "Annuler les changements",
        message: "Êtes-vous sûr d'annuler les changements courants?",
        buttons: {				
          remove: {
            label: L('YES_WORD'),
            className: "btn-danger",
            callback: function() {
              _this.services = JSON.parse(JSON.stringify(_this.oldItems));
              _this.recomputeItems();
            }
          },					
          cancel: {
            label: L("CANCEL"),
            className: "btn",
            callback: function() {

            }
          }
        }
      })
    },
    checkboxOrderStatusChange(item, value, event){
      item.invoice_detail_parts_status = (item.invoice_detail_parts_status == value) ? 0 : value;
      this.handleChange(item);
    },
    handleChange(changedItem = null) {
      const subtotalOk = this.applySubtotalMarkersFromItems();
      if (!subtotalOk) {
        this.recomputeItems();
        return;
      }

      let i = 0;
      for (const item of this.items) {
        if (item.is_subtotal_row) {
          continue;
        }
        item.invoice_detail_order = i++;
      }
      this.recomputeItems();
      return this.saveItems(changedItem);
    },
    initInvoiceTemplateSelect2(){
      var that = this;
      var sel = "body";
      if (this.formMode)
        sel = ".modal-invoice";
      $(sel+" #invoice_template_select").select2({
        language: "fr",
        tags: true,
        allowClear: true,
        placeholder: "",
        createTag: function (tag) {
          return {
            id: tag.term,
            text: tag.term,
            isNew : true
          };
        },
        ajax: {
          url: this.baseEndpoint + 'invoicetemplate/select2/template',
          dataType: 'json',
          data: function (params) {
            let selected = $(this).find('option:selected');
            if (selected && selected[0] && selected[0].value)
            {
              selected = selected[0].value;
            } else selected = -1;
            return {
              search: params.term,
              page: params.page || 1,
              selectedId: selected
            }
          },
          processResults: function (data) {
            return data;
          }
        },
        dropdownParent: $(sel+" #invoice-details-table"),
        searchInputPlaceholder: "Rechercher...",
        templateResult: function(state){
          if (!state.id) {
            return "Chargement des résultats...";
          }

          if(state.name == null) {
            return $('<span>'+(state.text)+'</span>');
          } else {
            return $('<span class="margin-right-10">'+(state.text)+'</span><span class="bold small">'+(state.name)+'</span><br><span><small>'+(state.label)+'</small></span>');
          }
        }
      }).on("select2:select", function(data) {
        var dat = data.params.data;
        that.ApplyTemplateService(dat.id, that.invoiceId);
      });
  	},
    ApplyTemplateService(invoicetemplateid,invoiceid) {
      var message_text = "<h1>Affectation des services...<br>Veuillez patienter</h1>";
      App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });
      var that = this;

      $.post(this.baseEndpoint + 'invoicetemplate/gettemplatejson', {invoicetemplateid: invoicetemplateid}, async data => {
          
          if(data != null && data.length > 0) {
            // Add services
            for (const service of data) {
              that.addService(null, {
                service_id: service.id,
                service_name: service.name,
                service_description: service.description,
                service_selling_price: service.fixed_price,
                service_quantity_fixed: service.quantity,
                service_quantity_per_hour: service.hours,
                service_rate_per_hour: service.rate_price ?? service.default_rate_price,
                service_order_part_default: service.service_order_part_default ?? 0,
                parts: service.parts?.map(part => {
                  return {
                    part_id: part.id,
                    part_number: part.name,
                    part_name: part.description,
                    part_selling_price: part.fixed_price,
                    part_suggested_price: part.part_suggested_price,
                    part_cost_price: part.part_cost_price,
                    part_tire_tax: part.tire_tax,
                    part_quantity_fixed: part.quantity,
                    part_rate_per_hour: part.rate_price ?? part.default_rate_price,
                    part_inventory: part.part_inventory,
                    part_return: part.part_return,
                    supplier_name: part.supplier_name,
                    part_core_part_id: part.part_core_part_id,
                    part_core_of_part_id: part.part_core_of_part_id,
                    part_core_part_item: part.part_core_part_item,
                  }
                })
              }, true)
            }
          }

          App.unblockUI();
          console.log('services added to ui..');
          await this.saveItems();
      });

      // Le invoice id peut être null ou 0 dans le cas d'un nouveau bon de travail, donc faut aller chercher les services et les pièces
      // Pour aller les ajouter côté front-end seulement.

		  //let request =  $.ajax({
			//url: this.baseEndpoint + 'invoicetemplate/applytemplate',
			//type: "POST",
			//data: {invoicetemplateid: invoicetemplateid,invoiceid: invoiceid},
			//dataType: "json"
		  //});
      //request.done(function (data) {
      //  console.log(data);
      //  if (!data || data == null) {
      //    App.unblockUI();
      //    toastr.error("Le serveur a retourné une erreur. Le service n'est plus valide ou effacé.");
      //    return;
      //  }
      //  that.loadItems();
      //  App.unblockUI();
      //});
      //request.fail(function(jqXHR, textStatus, thrownErr) {
      //  App.unblockUI();
      //  processXHRError(jqXHR, textStatus, thrownErr);
      //  console.log( "Request service infofailed: " + textStatus );
      //});
	  },
    getVehicleData(vehicle_id){ 
      this.vehicleId = vehicle_id;
      var that = this;
      App.blockUI();  
      $.post(this.baseEndpoint + "vehicle/fetchinfo", { id : vehicle_id }, function(json) {
        if (window.Select2Component && window.Select2Component.setStoredAlert) {
          window.Select2Component.setStoredAlert(json.data && json.data.stored_alert);
        }
        that.assignVehicleServiceData(vehicle_id, json.data, json.vehicle_display);
      }, "json", function(jqXHR, textStatus, thrownErr) {
        App.unblockUI();
        processXHRError(jqXHR, textStatus, thrownErr);
        console.log("Request getVehicleData failed: " + textStatus);
      });
    },
    assignVehicleServiceData(vehicle_id, data, display) {
      if (vehicle_id != this.vehicleId && display == null){
        this.getVehicleData(vehicle_id);
        return;
      }
      
      //$("#invoice_vehicle_display, .modal-invoice #invoice_vehicle_display").html('<option value="'+vehicle_id+'" selected>'+display+'</option>');
      //$("#invoice_vehicle_display, .modal-invoice #invoice_vehicle_display").val(vehicle_id);
      let vehicleDisplay=$("a.action-modify-vehicle, .modal-invoice a.action-modify-vehicle");
      if (vehicleDisplay.length) {
        if (data.vehicle_important_note && data.vehicle_important_note.length>0)
          vehicleDisplay.addClass('alert-extreme');
        else 
          vehicleDisplay.removeClass('alert-extreme');
        vehicleDisplay.text(display ?? data.text);
        vehicleDisplay.attr("vehicle-id", vehicle_id);
      }
      $("#data-add-service-tire, .modal-invoice #data-add-service-tire").val(data.vehicle_service_tire_id);

      if (data.vehicle_service_tire_id>0 && data.vehicle_service_tire_id !== null) {
        $("#action-add-service-tire, .modal-invoice #action-add-service-tire").removeClass("hidden");
      } else {
        $("#action-add-service-tire, .modal-invoice #action-add-service-tire").addClass("hidden");
      }
      $("#data-add-service-storage, .modal-invoice #data-add-service-storage").val(data.vehicle_service_storage_id);

      if (data.vehicle_service_storage_id>0 && data.vehicle_service_storage_id !== null) {
        $("#action-add-service-storage, .modal-invoice #action-add-service-storage").removeClass("hidden");
      } else {
        $("#action-add-service-storage, .modal-invoice #action-add-service-storage").addClass("hidden");
      }
      $("#data-add-service-oil, .modal-invoice #data-add-service-oil").val(data.vehicle_service_oil_id);
      $("#data-add-service-oil-qty, .modal-invoice #data-add-service-oil-qty").val(data.vehicle_oil_quantity);

      if (data.vehicle_service_oil_id>0 && data.vehicle_service_oil_id !== null) {
        $("#action-add-service-oil, .modal-invoice #action-add-service-oil").removeClass("hidden");
      } else { 
        $("#action-add-service-oil, .modal-invoice #action-add-service-oil").addClass("hidden"); 
      }

      $("#data-add-part-oil-filter, .modal-invoice #data-add-part-oil-filter").val(data.vehicle_part_oil_filter_id);

      $("#data-add-service-tpms, .modal-invoice #data-add-service-tpms").val(data.vehicle_tpms_shortcut_service_id);

      if (parseInt(data.vehicle_is_tpms) === 1) {
        $("#action-add-service-tpms, .modal-invoice #action-add-service-tpms").removeClass("hidden");
      } else {
        $("#action-add-service-tpms, .modal-invoice #action-add-service-tpms").addClass("hidden");
      }
      App.unblockUI();
    },
    actionaddservicetire() {
      var vehicle_id = this.vehicleId;
      var service_id = $("#data-add-service-tire").val();
      if(vehicle_id == null || vehicle_id <= 0 || service_id == null || service_id.trim() == "" || service_id == 0){
        toastr.error("Vous devez sélectionner un véhicule et son service de pneu avant d'effectuer cette action.");
        return;
      }	
      this.getService(service_id);	
    },
    actionaddservicestorage() {
      var vehicle_id = this.vehicleId;
      var service_id = $("#data-add-service-storage").val();
      if(vehicle_id == null || vehicle_id <= 0 || service_id == null || service_id.trim() == "" || service_id == 0){
        toastr.error("Vous devez sélectionner un véhicule et son service de pneu avant d'effectuer cette action.");
        return;
      }	
      this.getService(service_id);	
    },
    actionaddserviceoil() {
      var vehicle_id = this.vehicleId;
      var service_id = $("#data-add-service-oil").val();
      var oil_qty = $("#data-add-service-oil-qty").val();
      var part_id = $("#data-add-part-oil-filter").val();
      if(vehicle_id == null || vehicle_id <= 0 || service_id == null || service_id.trim() == "" || service_id == 0){
        toastr.error("Vous devez sélectionner un véhicule et son service d'huile avant d'effectuer cette action.");
        return;
      }
      this.getService(service_id,part_id, oil_qty);		
    },
    actionaddservicetpms() {
      var vehicle_id = this.vehicleId;
      var service_id = $("#data-add-service-tpms").val();
      if(vehicle_id == null || vehicle_id <= 0 || service_id == null || service_id.toString().trim() == "" || parseInt(service_id) <= 0){
        toastr.error("Le service TPMS n'est pas configuré ou n'est plus disponible.");
        return;
      }

      this.getService(service_id);
    },
    getService(id,part_id,qty) {
      let that = this;
      let request =  $.ajax({
        url: this.baseEndpoint + 'service/get/'+id,
        type: "POST",
        data: {},
        dataType: "json"
        });
      request.done(function (data) {
        if (!data || data == null) {
          toastr.error("Le serveur n'a pas retourné de service. Le service n'est plus valide ou effacé.");
          return;
        }
        // Ajouter la quantité du véhicule si elle dépasse la quantité par défaut du service.
        const requestedQuantity = parseFloat(String(qty).replace(",", "."));
        const serviceQuantity = parseFloat(String(data.service_quantity_fixed).replace(",", "."));
        if (Number.isFinite(requestedQuantity) && requestedQuantity > (Number.isFinite(serviceQuantity) ? serviceQuantity : 0)){
          data.service_quantity_fixed=requestedQuantity;
        }
        if (part_id<=0 || part_id == null){
          that.addService(null, data, true);	
          that.handleChange(that.services[that.services.length - 1]);
        } else {
          that.getPart(part_id, data);
        }
      });
      request.fail(function(jqXHR, textStatus, thrownErr) {
        App.unblockUI();
        processXHRError(jqXHR, textStatus, thrownErr);
        console.log( "Request service infofailed: " + textStatus );
      });
    },
    getPart(id, servicedata) {
      let that = this;
      let request =  $.ajax({
        url: this.baseEndpoint + 'part/get/'+id,
        type: "POST",
        data: {},
        dataType: "json"
        });
      request.done(function (data) {
        if (!data || data == null) {
          console.log("Le serveur n'a pas retourné de pièce. La pièce n'est plus valide ou effacée.");
          return;
        }
            console.log(data);
        servicedata.part = data;
        that.addService(null, servicedata, true);	
        that.handleChange(that.services[that.services.length - 1]);
      });
      request.fail(function(jqXHR, textStatus, thrownErr) {
        App.unblockUI();
        processXHRError(jqXHR, textStatus, thrownErr);
        console.log( "Request part infofailed: " + textStatus );
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-save-controls {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.invoice-save-controls .btn {
  padding: 2px 6px;
}

.invoice-saved-indicator {
  margin-left: 6px;
  color: #26a65b;
  font-size: 16px;
}

.invoice-details-grid-wrapper {
  position: relative;
  clear: both;
}

.invoice-details-grid-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.75);
  font-size: 18px;
}

.invoice-details-portlet{
  td.input{
    padding: 2px !important;
  }

  td.cb{
    text-align: center;
  }

  td.cb input{
    width: 18px;
    height: 18px;
  }

  td.cb .invoice_detail_parts_status_div{
    vertical-align: top;
  }

  td.cb input.invoice_detail_parts_status{
    width: 16px;
    height: 16px;
    margin-top: 0;
    vertical-align: middle;
  }

  .width-min-nowrap{
    width: 1%;
    white-space: nowrap;
  }
  
  .item-row:hover{
    background-color: rgb(204, 232, 255) !important;
  }

  .is-done {
    background-color: rgb(175, 175, 175) !important;
  }

  .item-row {
    &.is-service {
      background-color: #fff;
      border-top: 50px solid #e7ecf1;

      td {
        padding-top: 8px !important;
      }
    }

    &:not(.is-service) {
      background-color: #cedae6
    }

    &.is-subtotal-row {
      background-color: #f0f0f0 !important;

      td {
        padding-top: 8px !important;
      }
    }

    &.is-unselected {
      opacity: 0.55;

      td,
      input,
      textarea,
      .select2-selection__rendered {
        text-decoration: line-through;
      }
    }
  }

  .soumission-part-selected {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-right: 5px;
    font-size: 10px;
    line-height: 1.1;
    vertical-align: middle;
    cursor: pointer;

    input {
      width: 14px;
      height: 14px;
      margin: 0 0 2px;
    }
  }

  .soumission-core-label {
    display: inline-block;
    margin-right: 5px;
    color: #777;
    font-size: 9px;
    line-height: 1.1;
    text-align: center;
    vertical-align: middle;
  }

  input.invoice_detail_hours, input.invoice_detail_hour_rate  {
    color: #fff;
    background-color: #26c281;
  }

  .soumission-group-cell .soumission-group-text {
    display: block;
    max-width: 62px;
    padding: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .soumission-compact-col {
    font-size: 13px;
    line-height: 1.2;
  }
  td.soumission-compact-col {
    padding: 0 !important;
  }
  .soumission-compact-col input {
    font-size: 13px;
    line-height: 1.2; 
    padding: 0;
    text-align: center;
  }
  .invoice_detail_parts_status_div label {
      font-size: 15px;
  }

  .form-control.invoice_detail_qty, .form-control.invoice_detail_hours {
    width: 70px; 
    margin: 0; 
    padding: 0;
  }

  input.invoice_detail_is_selected {
      width: 16px;
      height: 16px;
      accent-color: #c65d00;
      cursor: pointer;
  }
}
</style>
